interface ScoutThinkingProps {
    /** Status text shown while Scout works (e.g. a tool-call progress message). Omit for the plain dots-only indicator. */
    statusText?: string;
}

/**
 * Animated thinking indicator with pulsating dots.
 * Used to show that Scout is thinking.
 */
const ScoutThinking: React.FC<ScoutThinkingProps> = ({ statusText }) => {
    return (
        <div className="flex justify-start mb-8">
            <div className="bg-white text-gray-900 border border-gray-200 px-3.5 py-2 rounded-lg">
                <div className="flex items-center gap-1">
                    {statusText && <span className="text-sm text-gray-600">{statusText}</span>}
                    <div className="flex space-x-[3px]">
                        <div className="w-2 h-2 bg-gray-500 rounded-full animate-pulsate"></div>
                        <div
                            className="w-2 h-2 bg-gray-500 rounded-full animate-pulsate"
                            style={{ animationDelay: "0.3s" }}
                        ></div>
                        <div
                            className="w-2 h-2 bg-gray-500 rounded-full animate-pulsate"
                            style={{ animationDelay: "0.6s" }}
                        ></div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ScoutThinking;
